import { z } from "zod";

export const CSV_EXPORT_TYPE_VALUES = ["QUOTE"] as const;
export const CsvExportTypeSchema = z.enum(CSV_EXPORT_TYPE_VALUES);
export type CsvExportType = z.infer<typeof CsvExportTypeSchema>;
export const CSV_EXPORT_TYPE = CsvExportTypeSchema.enum;

export const CSV_EXPORT_STATUS_VALUES = [
  "QUEUED",
  "PROCESSING",
  "COMPLETE",
  "FAILED",
] as const;
export const CsvExportStatusSchema = z.enum(CSV_EXPORT_STATUS_VALUES);
export type CsvExportStatus = z.infer<typeof CsvExportStatusSchema>;
export const CSV_EXPORT_STATUS = CsvExportStatusSchema.enum;

export const CreateQuoteLinesCsvExportRequestSchema = z.object({
  startDate: z.coerce.date(),
  endDate: z.coerce.date(),
  sendEmail: z.boolean().optional().default(false),
  includeCustomFields: z.boolean().optional().default(true),
});
export type CreateQuoteLinesCsvExportRequest = z.infer<
  typeof CreateQuoteLinesCsvExportRequestSchema
>;

export const CsvExportResponseSchema = z.object({
  id: z.string(),
  status: CsvExportStatusSchema,
  downloadUrl: z.string().nullable(),
  fileName: z.string().nullable(),
  errorMessage: z.string().nullable(),
  createdAt: z.coerce.date(),
});
export type CsvExportResponse = z.infer<typeof CsvExportResponseSchema>;

export const CreateCsvExportResponseSchema = z.object({
  export: CsvExportResponseSchema,
});
export type CreateCsvExportResponse = z.infer<
  typeof CreateCsvExportResponseSchema
>;

export const GetCsvExportResponseSchema = z.object({
  export: CsvExportResponseSchema,
});
export type GetCsvExportResponse = z.infer<typeof GetCsvExportResponseSchema>;
